import * as React from "react";
import {injectIntl, InjectedIntlProps, FormattedMessage} from "react-intl";
import { withRouter, RouteComponentProps } from "react-router";
import "./NavGoBack.less";
import {LeftOutlined} from "@ant-design/icons/lib";
export type NavGoBackProps = { title: React.ReactNode } & InjectedIntlProps & RouteComponentProps<{}>;


class NavGoBack extends React.Component<NavGoBackProps, {}> {
    public constructor(props: NavGoBackProps) {
        super(props);
    }

    private handleGoBack = (): void => {
        this.props.history.goBack();
    }

    public render(): React.ReactNode {
        return (
            <div className="product-center-nav">
                <div className="product-center-nav-inner-box">
                    <div className="sub-nav-left">
                        <div onClick={this.handleGoBack} className="sub-nav-left-back">
                            <LeftOutlined style={{fontSize: 12, marginRight: 4}} />
                            <FormattedMessage id={"sub-nav.go-back"}/>
                        </div>
                        <div className="sub-nav-left-mid"/>
                        <div className="sub-nav-left-title">{this.props.title}</div>
                    </div>
                </div>
            </div>
        );
    }

}

export default withRouter(injectIntl(NavGoBack));



// WEBPACK FOOTER //
// ./src/components/portal/NavGoBack.tsx